import { ReactElement } from 'react';

import { FormContextValues } from '@dreryk/react-common';

import { dischargeSummaryTranslationKeys } from '../../../../translations';

import { StyledProvidedMedicalServiceDescriptionField } from './ProvidedMedicalServiceDescriptionField.styled';

type ProvidedMedicalServiceDescriptionFormBeanPart = {
   providedMedicalServiceDescription: string | null;
};

type ProvidedMedicalServiceDescriptionFieldProps = Pick<
   FormContextValues<ProvidedMedicalServiceDescriptionFormBeanPart>,
   'register'
>;

const PROVIDED_MEDICAL_SERVICE_DESCRIPTION_MAX_LENGTH = 600;

export const ProvidedMedicalServiceDescriptionField = (
   props: ProvidedMedicalServiceDescriptionFieldProps
): ReactElement => {
   return (
      <StyledProvidedMedicalServiceDescriptionField
         testId={'providedMedicalServiceDescription'}
         controller={props.register('providedMedicalServiceDescription', { required: true })}
         maxLength={PROVIDED_MEDICAL_SERVICE_DESCRIPTION_MAX_LENGTH}
         label={dischargeSummaryTranslationKeys.providedMedicalServiceDescription}
         placeholder={dischargeSummaryTranslationKeys.fillProvidedMedicalServiceDescription}
         fillParent
      />
   );
};
